import { z } from 'zod';

/**
 * Login form validation schema.
 *
 * Validates email format and ensures password is provided.
 * Used in LoginPage before calling the auth API.
 */
export const loginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
  password: z.string().min(1, 'Password is required'),
  projectReference: z.string().optional(),
});

export type LoginFormData = z.infer<typeof loginSchema>;
